import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import React, { Component } from 'react';
import { apiFetch, API } from "../../services/api";

// Suppression par ?id= ; le back_api refuse un challenge en cours.
function deleteChallenge(challenge) {
    return apiFetch(API.back + '/challenge?id=' + encodeURIComponent(challenge.id), { method: 'DELETE' });
}

export default class DeleteChallengeModal extends Component {
    state = { loading: false, error: null };

    handleDelete = () => {
        this.setState({ loading: true, error: null });
        deleteChallenge(this.props.selectedItem)
            .then(async response => {
                if (!response.ok) {
                    const body = await response.json().catch(() => ({}));
                    throw new Error(body.message || "Erreur lors de la suppression");
                }
                if (this.props.refresh) await this.props.refresh();
                this.props.closeModal();
            })
            .catch(err => {
                console.log(err);
                this.setState({ loading: false, error: err.message || "Erreur lors de la suppression" });
            });
    };

    render() {
        const c = this.props.selectedItem || {};
        return (
            <Modal show={this.props.isOpen} onHide={this.props.closeModal} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Suppression du challenge {c.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Voulez-vous vraiment supprimer le challenge « {c.name} » ?</p>
                    <p className="text-muted">Les participants et leurs points ne sont pas supprimés de la base, mais la page /challenge/{c.slug} ne répondra plus. Un challenge en cours doit d'abord être clôturé.</p>
                    {this.state.error ? <p style={{ color: "#c0392b" }}>{this.state.error}</p> : null}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.props.closeModal}>Annuler</Button>
                    <Button variant="primary" onClick={this.handleDelete} disabled={this.state.loading}>
                        {this.state.loading ? "Suppression…" : "Valider"}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}
